import React from 'react';
import { ActivityIndicator } from 'react-native-paper';
import styled from 'styled-components/native';

import { Body2 } from '@src/components/Typography';

type Props = {
  loading?: boolean;
};

const Container = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100px;
`;

const Title = styled(Body2).attrs({
  numberOfLines: 1,
  ellipsizeMode: 'tail',
})`
  margin: 10px auto;
  color: ${({ theme }) => theme.colors.text};
  text-align: center;
`;

const Component: React.FC<Props> = ({ loading }) => {
  return (
    <Container>
      {loading ? (
        <ActivityIndicator />
      ) : (
        <Title>Nothing here! follow more people to view their activities</Title>
      )}
    </Container>
  );
};

Component.displayName = 'EmptyPosts';

export default React.memo(Component);
